import { DatePicker, List } from "antd";
import styles from "./WeeklyInspectionlist.module.css";
import { FaCalendarAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AntdDropdown, SearchInput } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import WeeklyInspectionMiddleware from "../../store/Middlewares/WeeklyInspectionMiddleware";
import CustomerMiddleware from "../../store/Middlewares/CustomerMiddlewares";
import { useTranslation } from "react-i18next";
import AlertAction from "../../store/Actions/AlertActions";
import moment from "moment";
import { MdSearch } from "react-icons/md";

const WeeklyInspectionlist = () => {
  useEffect(() => {
    getWeeklyInspection();
    getCleaner();
    getCustomer();
    getCompletedJobs();
    getLanguage();
    // const unsubscribe = navigation.addListener('focus', () => {
    //   getWeeklyInspection();
    // });
    // return unsubscribe;
  }, []);

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [CleanerList, setCleanerList] = useState([]);
  const [SelectedCleaner, setSelectedCleaner] = useState('');
  const [CustomerList, setCustomerList] = useState([]);
  const [SelectedCustomer, setSelectedCustomer] = useState('');
  const [dateFrom, setdateFrom] = useState('');
  const [dateTo, setdateTo] = useState('');
  const [date, setDate] = useState(new Date());
  const [LocationData, setLocationData] = useState([]);
  const [SelectedLocation, setSelectedLocation] = useState('');

  const getWeeklyInspectionReducerData = useSelector(
    state => state.WeeklyInspectionReducer.WeeklyInspectionList,
  );

  console.log('CleanerList', CleanerList)

  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language)
    } catch (e) {
      console.log(e)
    }
  };

  //Location
  const getCompletedJobs = () => {
    dispatch(WeeklyInspectionMiddleware.getCompletedJobs())
      .then(data => {
        setLocationData(data?.data);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const WeeklyInspectionPagination = useSelector(
    state => state.WeeklyInspectionReducer.WeeklyInspectionPagination,
  );

  const getWeeklyInspection = () => {
    let response = {
      cleaner_id: SelectedCleaner,
      customer_id: SelectedCustomer,
      location_id: SelectedLocation,
      date_from: dateFrom,
      date_to: dateTo,
      next_page_url: undefined,
    };
    dispatch(WeeklyInspectionMiddleware.getWeeklyInspection(response));
  };

  const getCleaner = () => {
    let data = {
      role: 'cleaner',
    };
    dispatch(CustomerMiddleware.getUsersByRole(data))
      .then(data => {
        setCleanerList(data?.data);
      })
      .catch(err => console.log(err));
  };

  const getCustomer = () => {
    let data = {
      role: 'customer',
    };
    dispatch(CustomerMiddleware.getUsersByRole(data))
      .then(data => {
        setCustomerList(data?.data);
      })
      .catch(err => console.log(err));
  };

  const onSearchTimeSheetList = () => {
    if ((!dateFrom && !dateTo) || (dateFrom && dateTo)) {
      let response = {
        cleaner_id: SelectedCleaner,
        customer_id: SelectedCustomer,
        location_id: SelectedLocation,
        date_from: dateFrom,
        date_to: dateTo,
        next_page_url: undefined,
      };
      dispatch(WeeklyInspectionMiddleware.getWeeklyInspection(response));
    } else if ((dateFrom && !dateTo) || (dateTo && !dateFrom)) {
      dispatch(AlertAction.ShowAlert({ type: "error", message: t('Please select date from and date too!') }))
    }
  };

  const onPressLoadMore = () => {
    let response = {
      next_page_url: WeeklyInspectionPagination?.links?.next,
    };
    dispatch(WeeklyInspectionMiddleware.getWeeklyInspection(response));
  };

  const loadMore =
    WeeklyInspectionPagination?.links?.next ? (
      <div
        style={{
          textAlign: 'center',
          marginTop: 12,
          height: 32,
          lineHeight: '32px',
          display: 'flex', justifyContent: 'center'
        }}
      >
        <button onClick={onPressLoadMore} className={styles.loadMore_button}>
          Load More
        </button>
      </div>
    ) : null;

  const navigate = useNavigate();
  const onChange = (date, dateString) => {
    console.log(date, dateString);
  };
  const dummyReports = [
    {
      id: 1,
      date: "Jan 7, 2022",
      name: "James",
      time: "10:25 AM",
      completedBy: "Alex John",
      location: "8675, NY City",
    },
    {
      id: 2,
      date: "Jan 7, 2022",
      name: "James",
      time: "10:25 AM",
      completedBy: "Alex John",
      location: "8675, NY City",
    },
  ];
  const handleChange = value => {
    console.log(value);
  };

  const onChangeDateFrom = (date, dateString) => {
    // console.log('onChangeDateFrom', dateString);
    setdateFrom(moment(dateString).format('YYYY-MM-DD'))
  };
  const onChangeDateTo = (date, dateString) => {
    // console.log('onChangeDateFrom', dateString);
    setdateTo(moment(dateString).format('YYYY-MM-DD'))
  };
  return (
    <div className={styles.mainCon}>
      <div className={styles.heading}>
        <h1>{t("Weekly Inspection")}</h1>
      </div>
      <div className={styles.firstRow}>
        {/* <div className={styles.firstRowCon}>
          <SearchInput placeholder={"Search"} style={{ width: '100%' }} />
        </div> */}
        <div className={styles.firstRowCon}>
          <DatePicker
            className={'datePicker'}
            placeholder={t("Date From")}
            style={{
              height: '44px',
              margin: '0px'
            }}
            suffixIcon={<FaCalendarAlt className={styles.calendarIcon} />}
            onChange={onChangeDateFrom}
          />
        </div>
        <div className={styles.firstRowCon}>
          <DatePicker
            className={'datePicker'}
            placeholder={t("Date To")}
            style={{
              height: '44px',
              margin: '0px'
            }}
            suffixIcon={<FaCalendarAlt className={styles.calendarIcon} />}
            onChange={onChangeDateTo}

          />
        </div>
        <div className={styles.firstRowCon}>
          <AntdDropdown
            // name={'Select Location'}
            placeholder={t('Select Location')}
            // label={'Role'}
            className={'yellow_border_class'}
            onChange={(val) => setSelectedLocation(val)}
            options={
              LocationData?.map((item) => { return ({ value: item?.id, option: item?.address }) })
            }
            style={{ width: '100%', height: '20px', borderColor: 'red' }}
          />
        </div>
      </div>
      <div className={styles.secondRow}>
        <div className={styles.firstRowCon}>
          <AntdDropdown
            // name={'Select Customer'}
            placeholder={t('Select Customer')}
            // label={'Role'}
            className={'yellow_border_class'}
            onChange={(val) => setSelectedCustomer(val)}
            options={
              CustomerList?.map((item) => { return ({ value: item?.id, option: item?.name }) })
            }
            style={{ width: '100%', height: '20px', borderColor: 'red' }}
          />
        </div>
        <div className={styles.firstRowCon}>
          <AntdDropdown
            // name={'Select Employee'}
            placeholder={t('Select Employee')}
            // label={'Role'}
            className={'yellow_border_class'}
            onChange={(val) => setSelectedCleaner(val)}
            options={
              CleanerList?.map((item) => { return ({ value: item?.id, option: item?.name }) })
            }
            style={{ width: '100%', height: '20px', borderColor: 'red' }}
          />
        </div>
        <div className={styles.firstRowCon}>
          <button onClick={() => onSearchTimeSheetList()} className={styles.Search_button}>
            <MdSearch
              style={{ width: 20, height: 20 }}
              color={"#ffff"}
            />
            {t("Search")}
          </button>
        </div>
      </div>
      <List
        grid={{
          gutter: 16,
          //   xs: 2,
          sm: 1,
          md: 1,
          lg: 1,
          xl: 2,
          xxl: 2,
        }}
        className={styles.list}
        footer={loadMore}
        dataSource={getWeeklyInspectionReducerData}
        renderItem={(item) => (
          <div
            key={item?.id}
            className={styles.listItem}
            onClick={() =>
              navigate("/contractorHome/WeeklyInspection/Details", { state: { reportData: item } })
            }
          >
            <div className={styles.listName}>
              {/* <h2>Report # {item?.id}</h2> */}
              <h3>{moment(item?.date).format('MM-DD-YYYY')}</h3>
            </div>
            <div className={styles.listFirstRow}>
              <div className={styles.FirstCol}>
                <span>{t("Name")}</span>
                <p>{item?.customer_name}</p>
              </div>
              <div className={styles.SecondCol}>
                <span>{t("Time")}</span>
                <p>{moment('01 jan 1947 ' + item?.time).format(' hh:mm A')}</p>
              </div>
            </div>
            <div className={styles.listSecondRow}>
              <div className={styles.FirstCol}>
                <span>{t("Completed by")}</span>
                <p>{item?.cleaner_name}</p>
              </div>
              <div className={styles.SecondCol}>
                <span>{t("Location")}</span>
                <p>{item?.location?.address}</p>
              </div>
            </div>

          </div>
        )}
      />
    </div>
  );
};
export default WeeklyInspectionlist;
;
